module.exports = __webpack_public_path__ + "static/media/rondleiding.b1c3cfa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Educatie/02_Voor-studenten/hq/rondleiding.jpg
// module id = 762
// module chunks = 0